import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initializeMsal } from '@/config/auth';

/**
 * Initialize MSAL before mounting React so that handleRedirectPromise()
 * completes before any component calls useMsal() or acquireToken().
 * (F4 owns this call per the architecture — AuthProvider doc confirms it.)
 */
initializeMsal().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}).catch((err: unknown) => {
  // MSAL initialization failing hard (network error, config error) should
  // still surface the app so the user sees something rather than a blank page.
  // Log the error and render anyway — the MSAL context will be degraded but
  // the public form (unauthenticated) still works.
  console.error('[MSAL] Initialization error:', err);
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
